import { render, staticRenderFns } from "./FinalizacaoTabs.vue?vue&type=template&id=47542449"
import script from "./FinalizacaoTabs.vue?vue&type=script&lang=js"
export * from "./FinalizacaoTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports